import type {
	Extension,
	ExtensionHandler,
	Parameters as ExtensionParameters,
} from '@atlaskit/editor-common/extensions';

import type { ADFRendererProps } from '@confluence/adf-renderer/entry-points/ADFRendererComponent';
import { expVal } from '@confluence/feature-experiments';
import {
	EXTENSION_KEY,
	EXTENSION_TYPE,
} from '@confluence/fabric-extension-lib/entry-points/extensionConstants';

export function createExtensionHandlersWithoutSSR(
	delegates: ADFRendererProps['extensionHandlers'],
): ADFRendererProps['extensionHandlers'] {
	if (!expVal('cc_complexit_fe_toc_without_ssr', 'createExtensionHandlersWithoutSSR', false)) {
		return undefined;
	}

	const extensionType = EXTENSION_TYPE.MACRO_CORE;
	const delegate = getExtensionRenderer(delegates?.[extensionType]);

	if (delegate) {
		return {
			[extensionType]: function extensionHandler(ext) {
				if (ext.extensionKey === EXTENSION_KEY.TOC && ext.extensionType === extensionType) {
					return delegate.apply(this, arguments as unknown as Parameters<ExtensionHandler>);
				} else {
					return null;
				}
			},
		};
	}
}

function getExtensionRenderer<T extends ExtensionParameters>(
	extensionHandler: Extension<T> | ExtensionHandler<T> | undefined,
): ExtensionHandler<T> | undefined {
	if (extensionHandler && typeof extensionHandler === 'object') {
		return extensionHandler.render;
	} else {
		return extensionHandler;
	}
}
